import React, { useState } from 'react';

// Order: Classic → Popular → Quick → then variants
const _ALL_MODES = [
    {
        value: 'classic',
        emoji: '🎯',
        label: 'Classic',
        subtitle: '1 vs 1',
        color: '#3b82f6',
        gradient: 'linear-gradient(135deg,#1e3a5f,#1d4ed8)',
        minPlayers: 2,
        en: 'All 4 tokens home to win. Cuts & Safe Zones active.',
        hi: 'सभी 4 गोटियाँ Home पहुंचाएं। Dice Cut और Safe Zone चालू।',
        rules_en: [
            'Played between 2–4 players.',
            'All 4 tokens must reach Home to win.',
            'Dice Cut system is enabled.',
            'Tokens on Safe Homes/Safe Boxes cannot be cut.',
            'Player who takes all 4 tokens Home first wins.',
        ],
        rules_hi: [
            'खेल में 2–4 खिलाड़ी भाग लेंगे।',
            'सभी 4 गोटियाँ Home पहुंचानी होंगी।',
            'Dice Cut चालू रहेगा।',
            'Safe Home / Safe Box पर गोटी नहीं कटेगी।',
            'सभी 4 गोटियाँ पहले Home पहुंचाने वाला Winner।',
        ],
    },
    {
        value: 'timer',
        emoji: '⏱️',
        label: 'Timer Race',
        subtitle: '2–10 Minute Match',
        color: '#06b6d4',
        gradient: 'linear-gradient(135deg,#083344,#0891b2)',
        minPlayers: 2,
        timerMinutes: [2, 4, 6, 8, 10],
        en: 'Play for a fixed time. Highest total pawn progress wins.',
        hi: 'तय समय तक खेलें। सभी गोटियों की सबसे बड़ी कुल चाल वाला Winner।',
        rules_en: [
            'Choose 2, 4, 6, 8 or 10 minutes before creating the room.',
            'Every pawn is scored fairly from 0 (base) to 57 (Home).',
            'The player with the highest total progress across all pawns wins.',
            'If totals are equal, the highest single-pawn progress wins.',
            'If still equal, the player using fewer progressed pawns wins.',
        ],
        rules_hi: [
            'Room बनाते समय 2, 4, 6, 8 या 10 मिनट चुनें।',
            'हर गोटी की चाल Base 0 से Home 57 तक गिनी जाएगी।',
            'सभी गोटियों की कुल चाल सबसे ज्यादा होने पर जीत होगी।',
            'कुल चाल बराबर हो तो सबसे आगे वाली एक गोटी Winner तय करेगी।',
            'फिर भी बराबर हो तो कम खुली गोटियों वाला खिलाड़ी जीतेगा।',
        ],
    },
    {
        value: 'reverse',
        emoji: '🔁',
        label: 'Reverse (Ulta)',
        subtitle: 'Ulta Classic',
        color: '#f59e0b',
        gradient: 'linear-gradient(135deg,#451a03,#b45309)',
        minPlayers: 2,
        en: 'First to finish all tokens = Loser. Last remaining = Winner.',
        hi: 'पहले Home पहुंचाने वाला Loser। अंत तक बचने वाला Winner।',
        rules_en: [
            'All Classic Ludo rules apply.',
            'Dice Cut and Safe Home systems remain active.',
            'The player who first takes all tokens Home is the Loser.',
            'The last remaining player becomes the Winner.',
        ],
        rules_hi: [
            'Classic Ludo के सभी नियम लागू होंगे।',
            'Dice Cut और Safe Home सिस्टम चालू रहेगा।',
            'पहले सभी गोटियाँ Home पहुंचाने वाला Loser माना जाएगा।',
            'जो अंत तक बचा रहेगा, वही Winner होगा।',
        ],
    },
    {
        value: 'token_1',
        emoji: '1️⃣',
        label: '1-Token Win',
        subtitle: 'Speed Mode',
        color: '#10b981',
        gradient: 'linear-gradient(135deg,#064e3b,#059669)',
        minPlayers: 2,
        en: '2 tokens pre-opened. First to get 1 token Home wins.',
        hi: '2 गोटियाँ खुली। पहले 1 गोटी Home पहुंचाने वाला Winner।',
        rules_en: [
            '2 tokens remain open from the start.',
            'Dice Cut and Safe Home systems are enabled.',
            'First player to take 1 token Home wins.',
        ],
        rules_hi: [
            'गेम शुरू होते ही 2 गोटियाँ खुली रहेंगी।',
            'Dice Cut और Safe Home सिस्टम चालू रहेगा।',
            '1 गोटी Home पहुंचाने वाला Winner होगा।',
        ],
    },
    {
        value: 'token_2',
        emoji: '2️⃣',
        label: '2-Token Win',
        subtitle: 'Speed Mode',
        color: '#10b981',
        gradient: 'linear-gradient(135deg,#064e3b,#059669)',
        minPlayers: 2,
        en: '2 tokens pre-opened. First to get 2 tokens Home wins.',
        hi: '2 गोटियाँ खुली। पहले 2 गोटियाँ Home पहुंचाने वाला Winner।',
        rules_en: [
            '2 tokens remain open from the start.',
            'Dice Cut and Safe Home systems are enabled.',
            'First player to take 2 tokens Home wins.',
        ],
        rules_hi: [
            'गेम शुरू होते ही 2 गोटियाँ खुली रहेंगी।',
            'Dice Cut और Safe Home सिस्टम चालू रहेगा।',
            '2 गोटियाँ Home पहुंचाने वाला Winner होगा।',
        ],
    },
    {
        value: 'token_3',
        emoji: '3️⃣',
        label: '3-Token Win',
        subtitle: 'Speed Mode',
        color: '#10b981',
        gradient: 'linear-gradient(135deg,#064e3b,#059669)',
        minPlayers: 2,
        en: '2 tokens pre-opened. First to get 3 tokens Home wins.',
        hi: '2 गोटियाँ खुली। पहले 3 गोटियाँ Home पहुंचाने वाला Winner।',
        rules_en: [
            '2 tokens remain open from the start.',
            'Dice Cut and Safe Home systems are enabled.',
            'First player to take 3 tokens Home wins.',
        ],
        rules_hi: [
            'गेम शुरू होते ही 2 गोटियाँ खुली रहेंगी।',
            'Dice Cut और Safe Home सिस्टम चालू रहेगा।',
            '3 गोटियाँ Home पहुंचाने वाला Winner होगा।',
        ],
    },
    {
        value: 'no_cut',
        emoji: '✋',
        label: 'No Dice Cut',
        subtitle: 'Peace Mode',
        color: '#8b5cf6',
        gradient: 'linear-gradient(135deg,#2e1065,#7c3aed)',
        minPlayers: 2,
        en: '2 tokens pre-opened. Cutting any token = instant Loser.',
        hi: '2 गोटियाँ खुली। गोटी काटना = तुरंत Loser।',
        rules_en: [
            '2 tokens remain open from the start.',
            'Players must NOT cut opponents\' tokens.',
            'Cutting any opponent\'s token = immediate Loser.',
            'First to reach required tokens Home (without cuts) wins.',
            'Safe Home rules remain active.',
        ],
        rules_hi: [
            'गेम शुरू होते ही 2 गोटियाँ खुली रहेंगी।',
            'किसी भी खिलाड़ी को गोटी काटनी नहीं है।',
            'गोटी काटने पर तुरंत Loser घोषित किया जाएगा।',
            'बिना Dice Cut के निर्धारित गोटियाँ Home पहुंचाने वाला Winner।',
            'Safe Home नियम लागू रहेगा।',
        ],
    },
    {
        value: 'team_2v2',
        emoji: '🤝',
        label: '2 vs 2 Team',
        subtitle: 'Team Mode',
        color: '#ec4899',
        gradient: 'linear-gradient(135deg,#500724,#be185d)',
        minPlayers: 4,
        en: '4 players, 2 teams. Team with all 8 tokens Home wins.',
        hi: '4 खिलाड़ी, 2 टीमें। 8 गोटियाँ Home → Team जीतती है।',
        rules_en: [
            '4 players play in teams of 2 (2 vs 2).',
            'Team A = 🔴 Red + 🟢 Green   |   Team B = 🔵 Blue + 🟡 Yellow',
            'Each team has a total of 8 tokens.',
            'Players can cut only the opponent team\'s tokens.',
            'A finished teammate may assist their partner.',
            'First team to take all 8 tokens Home wins.',
        ],
        rules_hi: [
            '4 खिलाड़ी 2 टीमों में खेलेंगे (2 vs 2)।',
            'Team A = 🔴 लाल + 🟢 हरा   |   Team B = 🔵 नीला + 🟡 पीला',
            'टीम के दोनों खिलाड़ियों की कुल 8 गोटियाँ होंगी।',
            'खिलाड़ी केवल विरोधी टीम की गोटियाँ काट सकते हैं।',
            'एक खिलाड़ी finish करने पर partner की मदद कर सकता है।',
            'जिस टीम की सभी 8 गोटियाँ पहले Home पहुंचें, वही Winner।',
        ],
    },
    {
        value: 'popular',
        emoji: '🔥',
        label: 'Popular',
        subtitle: 'Reroll Edition',
        popular: true,
        color: '#f97316',
        gradient: 'linear-gradient(135deg,#431407,#c2410c)',
        minPlayers: 2,
        en: 'Classic rules + each player gets 3 🔄 dice re-rolls per game.',
        hi: 'Classic नियम + हर खिलाड़ी को पूरे game में 3 बार Dice दोबारा फेंकने का मौका।',
        rules_en: [
            'All Classic Ludo rules apply (cuts, Safe Zones, etc.).',
            'Each player gets exactly 3 dice re-rolls per game.',
            'After rolling, tap 🔄 to re-roll if you don\'t like the result.',
            'Re-rolls are per-player and do NOT reset between turns.',
            'Use wisely — once all 3 are spent, no more re-rolls.',
        ],
        rules_hi: [
            'Classic Ludo के सभी नियम लागू होंगे।',
            'हर खिलाड़ी को पूरे game में सिर्फ 3 बार Dice दोबारा फेंकने का मौका मिलेगा।',
            'Dice फेंकने के बाद 🔄 बटन दबाकर दोबारा फेंक सकते हैं।',
            'Re-roll की संख्या turn-by-turn reset नहीं होती — game-wide है।',
            'सोच-समझकर इस्तेमाल करें, 3 खत्म होने के बाद Re-roll नहीं मिलेगा।',
        ],
    },
    {
        value: 'quick',
        emoji: '⚡',
        label: 'Quick',
        subtitle: 'Fast Classic',
        color: '#00d4ff',
        gradient: 'linear-gradient(135deg,#0c4a6e,#0284c7)',
        minPlayers: 2,
        en: '2 tokens pre-opened. All 4 tokens Home to win. Fast game.',
        hi: '2 गोटियाँ शुरू से खुली। 4 गोटियाँ Home = Win। तेज़ खेल।',
        rules_en: [
            '2 tokens per player are pre-opened at game start.',
            'All 4 tokens must still reach Home to win (classic win condition).',
            'Dice Cut and Safe Home remain active.',
            'Pre-opened tokens skip the "need a 6 to open" rule.',
            'Faster than Classic — great for quick games.',
        ],
        rules_hi: [
            'खेल शुरू होते ही हर खिलाड़ी की 2 गोटियाँ पहले से खुली होंगी।',
            'जीत के लिए सभी 4 गोटियाँ Home पहुंचानी होंगी।',
            'Dice Cut और Safe Home के नियम लागू रहेंगे।',
            'खुली गोटियों को 6 आने की ज़रूरत नहीं।',
            'Classic से तेज़ — जल्दी खेलने के लिए बेस्ट।',
        ],
    },
];

// Reorder so classic → popular → quick appear first
const _ORDER = ['classic', 'popular', 'quick', 'timer'];
export const GAME_MODE_DEFS = [
    ..._ORDER.map(v => _ALL_MODES.find(m => m.value === v)).filter(Boolean),
    ..._ALL_MODES.filter(m => !_ORDER.includes(m.value)),
];

// ── Compact picker (used inside Host modal) ───────────────────────────────
export const ModeSelector = ({ value, onChange, maxHeight = 420 }) => {
    const [expandedId, setExpandedId] = useState(null);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight, overflowY: 'auto', paddingRight: 4 }}>
            {GAME_MODE_DEFS.map(mode => {
                const isSelected = value === mode.value;
                const isExpanded = expandedId === mode.value;
                return (
                    <div key={mode.value}
                        style={{
                            borderRadius: 12,
                            border: `2px solid ${isSelected ? mode.color : 'rgba(255,255,255,0.12)'}`,
                            background: isSelected ? `${mode.color}22` : 'rgba(255,255,255,0.04)',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                        onClick={() => { onChange(mode.value); setExpandedId(isExpanded ? null : mode.value); }}
                    >
                        {/* Row */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px' }}>
                            {/* Radio dot */}
                            <div style={{
                                width: 18, height: 18, borderRadius: '50%',
                                border: `2px solid ${isSelected ? mode.color : 'rgba(255,255,255,0.35)'}`,
                                background: isSelected ? mode.color : 'transparent',
                                flexShrink: 0,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                {isSelected && <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'white' }} />}
                            </div>
                            <span style={{ fontSize: 22, flexShrink: 0 }}>{mode.emoji}</span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ color: 'white', fontWeight: isSelected ? 700 : 500, fontSize: 14 }}>{mode.label}</span>
                                    {mode.popular && (
                                        <span style={{ fontSize: 9, fontWeight: 800, padding: '1px 6px', borderRadius: 20, background: 'linear-gradient(90deg,#f97316,#ef4444)', color: '#fff', letterSpacing: 0.5 }}>POPULAR</span>
                                    )}
                                    {mode.value === 'popular' && (
                                        <span style={{ fontSize: 9, color: '#fb923c' }}>🔄 3 rerolls</span>
                                    )}
                                </div>
                                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11 }}>{mode.en}</div>
                            </div>
                            {/* Expand toggle */}
                            <button
                                onClick={e => { e.stopPropagation(); setExpandedId(isExpanded ? null : mode.value); }}
                                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 12, padding: '2px 4px' }}
                            >
                                {isExpanded ? '▲' : '▼'}
                            </button>
                        </div>

                        {/* Expanded rules */}
                        {isExpanded && (
                            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '10px 14px 12px 46px', background: 'rgba(0,0,0,0.2)' }}>
                                <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 11.5, marginBottom: 6, fontWeight: 600 }}>Rules:</div>
                                {mode.rules_en.map((r, i) => (
                                    <div key={i} style={{ display: 'flex', gap: 7, marginBottom: 4, color: 'rgba(255,255,255,0.7)', fontSize: 12, lineHeight: 1.4 }}>
                                        <span style={{ color: mode.color, fontWeight: 700, flexShrink: 0 }}>{i + 1}.</span>
                                        <span>{r}</span>
                                    </div>
                                ))}
                                <div style={{ marginTop: 8, paddingTop: 6, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                                    {mode.rules_hi.map((r, i) => (
                                        <div key={i} style={{ display: 'flex', gap: 7, marginBottom: 4, color: 'rgba(255,220,100,0.75)', fontSize: 11.5, lineHeight: 1.4 }}>
                                            <span style={{ fontWeight: 700, flexShrink: 0 }}>🇮🇳</span>
                                            <span>{r}</span>
                                        </div>
                                    ))}
                                </div>
                                {mode.minPlayers > 2 && (
                                    <div style={{ marginTop: 8, padding: '4px 8px', background: `${mode.color}22`, borderRadius: 6, color: mode.color, fontSize: 11 }}>
                                        ⚠️ Requires {mode.minPlayers} players
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ModeSelector;
